
<ng-container *ngIf="windowed">
  <div class="hidden">
    <button *ngIf="!warehousing" class="nrk-button mt-2" (click)="boxLabelWindow.show(); loadData()">Print Box Labels</button>
    <button *ngIf="warehousing" class="btn btn-info btn-md" (click)="boxLabelWindow.show(); loadData()">Print Box Labels</button>
  </div>

  <nrk-window #boxLabelWindow>

    <nrk-header><b>Box Labels</b></nrk-header>

    <nrk-content>
      <ng-container *ngTemplateOutlet="boxSheetsTemplate;"></ng-container>
    </nrk-content>

    <nrk-footer>
      <div style="text-align:center">
        <button class="btbtn nrk-button mr-2" (click)="print = !print">debug</button>
        <button class="btbtn nrk-button mr-2" (click)="selectAll()">Select All</button>
        <button class="btbtn nrk-button mr-2" (click)="selectNone()">Select None</button>
        <button class="btbtn nrk-button ml-4 mr-2" (click)="saveBoxes()" [attr.disabled]="checkDisabled('save')">SaveBoxes</button>
        <button class="btbtn nrk-button mr-4" (click)="printLabels()" [attr.disabled]="checkDisabled('download')">Download PDF Labels</button>
        <button class="btbtn nrk-button ml-4" (click)="boxLabelWindow.hide()">Close</button>
      </div>
    </nrk-footer>

  </nrk-window>
</ng-container>


<ng-container *ngIf="!windowed">
  <ng-container *ngTemplateOutlet="boxSheetsTemplate;"></ng-container>
</ng-container>


<ng-template #boxSheetsTemplate>
    <div #boxLabel>

      <div *ngIf="!print && compilation.boxLabelConfig" class="p-4" style="background-color:#eee;margin:4px">
        <div class="row">

          <div class="ml-2 mr4">
            <nb-radio-group name="shelfLifeGroup" [(ngModel)]="compilation.boxLabelConfig.mode">
              <nb-radio [value]="1">Standard</nb-radio>
              <nb-radio [value]="2">Override</nb-radio>
              <nb-radio [value]="3">Expiry Column</nb-radio>
              <nb-radio [value]="4">Expiry = Product Date + Month</nb-radio>
              <nb-radio [value]="8">Expiry = Dispatch Date + Month</nb-radio>
              <nb-radio [value]="5">Keep Current</nb-radio>
              <nb-radio [value]="6">Remark</nb-radio>
              <nb-radio [value]="7">Remark Page</nb-radio>
            </nb-radio-group>
          </div>

          <div>
            <div>
              <label class="mr-2">Gross Weigth override</label>
              <input [(ngModel)]="grossWeightOverride" /> kg
            </div>

            <div *ngIf="compilation.boxLabelConfig.mode === 1" class="shelf-life-option">
              <label>Shelf Life Override Text:</label><br>
              <ng-container *ngFor="let prod of finishedProductShelfLifeOptions | keyvalue">
                <div class="text-muted">{{prod.value.name}}:</div>
                Min Shelf life at 
                <input [(ngModel)]="prod.value.degrees" /> °C: 
                <input [(ngModel)]="prod.value.months" /> months
              </ng-container>
            </div>

            <div *ngIf="compilation.boxLabelConfig.mode === 2" class="shelf-life-option">
              <label>Shelf Life Override Text:</label>
              <ngx-form-text [multiline]="1" [(value)]="shelfLifeText"></ngx-form-text>
              <label>Shelf Life Override Date:</label>
              <ngx-doc-form-date [(value)]="shelfLifeDate"></ngx-doc-form-date>
            </div>

            <div *ngIf="compilation.boxLabelConfig.mode === 3" class="shelf-life-option">
              <ng-container *ngFor="let prod of finishedProductShelfLifeOptions | keyvalue">
                <div>Storage conditions: <input [(ngModel)]="prod.value.degrees" /> °C:</div>
              </ng-container>
            </div>

            <div *ngIf="compilation.boxLabelConfig.mode === 4" class="shelf-life-option">
              <ng-container *ngFor="let prod of finishedProductShelfLifeOptions | keyvalue">
                <div>Storage conditions: <input [(ngModel)]="prod.value.degrees" /> °C:</div>
              </ng-container>
              <label  class="mr-2">Expiry = Production Date + Months:</label>
              <input [(ngModel)]="expiryMonths" /> Months
            </div>

            <div *ngIf="compilation.boxLabelConfig.mode === 6 || compilation.boxLabelConfig.mode === 7">
              <div class="mt-2"><input type="checkbox" [(ngModel)]="compilation.boxLabelConfig.textCentered"/> Text Centered</div>
              <div class="mt-2">Remarks Font Size (pt) <ngx-doc-form-texfield [(value)]="compilation.boxLabelConfig.fontSize" mode="integer"></ngx-doc-form-texfield></div>
              <div class="mb-2">Remarks:</div>
              <ngx-form-text [multiline]="5" [(value)]="compilation.boxLabelConfig.remarks"></ngx-form-text>
            </div>

            <div *ngIf="compilation.boxLabelConfig.mode === 8" class="shelf-life-option">
              <ng-container *ngFor="let prod of finishedProductShelfLifeOptions | keyvalue">
                <div>Shelf Life: <input [(ngModel)]="prod.value.degrees" /> °C:</div>
              </ng-container>
              <label  class="mr-2">Expiry = Dispatch Date + Months:</label>
              <input [(ngModel)]="expiryMonths" /> Months
            </div>

            <div>
              <div class="mt-4"><input type="checkbox" [(ngModel)]="this.isPortrait"/> Orientation: {{this.isPortrait ? 'Portrait' : 'Landscape'}}</div>
              <div class="mt-4"><input type="checkbox" [(ngModel)]="this.isA4"/> Paper Size: {{this.isA4 ? 'DIN A4' : 'DIN A5'}}</div>
              <div class="mt-4"><input type="checkbox" [(ngModel)]="this.showDateOfProd"/> Show Date of Production</div>
            </div>

          </div>

        </div>

        <button class="btn btn-sm btn-info mt-2" (click)="applyShelfLifeText()" [attr.disabled]="checkDisabled('apply')">Apply</button>

      </div>

      
      
      <!-- ==================================================== Box Label Pages ==================================================================== -->
      
      <ng-container *ngFor="let box of boxLabels">

        <!-- <div *ngIf="box.selected || !print" class="box-label-page">

          <div class="box-label-container">

          </div>

        </div> -->


        <div [class]="isA4 ? (isPortrait ? 'a4-wrapper-portrait' : 'a4-wrapper') : 'a5-wrapper'">

        <div [class]="this.isPortrait ? 'box-label-page-portrait' : 'box-label-page'">


          <div class="box-label-container"> 

            <div *ngIf="!print" class="selection-checkbox"><input type="checkbox" [(ngModel)]="box.selected" /></div>

            <div *ngIf="box.finishedProduct?.content?.energy?.core && !isPortrait" class="box-label-left">
              <div *ngIf="!this.isPortrait" class="qrcode"><qrcode [qrdata]="'{ boxId: ' + box.boxId + ' }'" [width]="120" [errorCorrectionLevel]="'Q'" elementType="svg"></qrcode></div>
              <div class="numbers-left"><div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Case #</div><div>{{box.box.case}}</div></div>
              <div class="numbers-left"><div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Box ID</div><div>{{box.boxId}}</div></div>
              <!-- <br *ngIf="" -->
              <div *ngIf="box.finishedProduct?.content?.energy?.core?.coreImage?.length && !isPortrait" class="core-image">
                <img [src]="'api/v1' + box.finishedProduct.content.energy.core.coreImage[0].url" />
              </div>
              <!-- <div class="numbers-left"><div>Net weight (kg)</div><div>{{box.netWeight | ngxRound : 2 : true}}<br>{{box.details[0].netWeight // '---'}}</div></div> -->
              <div class="numbers-left"><div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Quantity (m²)</div><div>{{getSqm(box)}}</div></div>
              <div class="numbers-left"><div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Net weight (kg)</div><div>{{box.netWeight | ngxRound : 2 : true}}</div></div>
              <div *ngIf="+box.box.grossWeightOverride > 0; else xlsGrossWeight" class="numbers-left">
                <div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Gross weight (kg)</div><div>{{(+box.box.grossWeightOverride).toFixed(2)}}</div>
              </div>
              <ng-template #xlsGrossWeight><div *ngIf="+box.grossWeight > 0" class="numbers-left">
                <div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Gross weight (kg)</div><div>{{(+box.grossWeight).toFixed(2)}}</div>
              </div></ng-template>
            </div>

            <div class="box-label-right">

              <div class="box-label-right-container"> 

                <div class="vcenter box-label-header">
                  <div class="block header-text">
                    <div class="header-upper">{{box.customer?.name}}</div>
                    <div class="header-lower">{{box.oc.customerDocumentNumber}} Pos {{tree.getItemOrderPos(box.lineItem)}}</div>
                  </div>
                  <div class="block nrk-logo"><img src="assets/images/nipponrika_logo.svg" /></div>
                </div>

                <div class="vcenter box-label-details">
                  <div class="details-table">
                    <table>
                      <tr>
                        <th>Customer Material Name:</th>
                        <td>{{box.dnLineItem?.attributeRemark ?? ''}}</td>
                      </tr>
                      <tr>
                        <th>Customer Material Code:</th>
                        <td>{{box.dnLineItem?.attributeCode ?? ''}}</td>
                      </tr>
                      <tr *ngIf="box.dnLineItem?.publicRemark">
                        <th>Remark:</th>
                        <td>{{box.dnLineItem?.publicRemark}}</td>
                      </tr>
                      <!-- <tr>
                        <th>Supplier Product Code:</th>
                        <td>{{box.finishedProduct.calcCode}}</td>
                      </tr> -->
                      <!-- <tr>
                        <th>Supplier Product Name:</th>
                        <td>{{box.finishedProduct.calcName?.split('; ')[0]}}</td>
                      </tr>
                      <tr>
                        <th>Dimensions:</th>
                        <td>{{box.finishedProduct.calcName?.split('; ')[1]}}</td>
                      </tr> -->
                    </table>                    
                  </div>
                  <div *ngIf="box.finishedProduct.customerIdentificator?.url" class="customer-identification">
                    <img [src]="'api/v1' + box.finishedProduct.customerIdentificator?.url" />
                  </div>
                </div>

                <div *ngIf="box.finishedProduct.content.energy" class="vcenter box-label-dimensions">
                  <table>
                    <!-- <tr class="product-name">
                      <th colspan="4">Supplier Product Name: <span>{{box.finishedProduct.calcName?.split('; ')[0]}}</span></th>
                    </tr> -->
                    <tr><td colspan="4" class="product-table">
                      <table>
                        <tr><th>Supplier Product Code: </th><th>{{box.finishedProduct.calcCode}}</th></tr>
                        <tr><th>Supplier Product Name: </th><th>{{box.finishedProduct.calcName?.split('; ')[0]}}</th></tr>
                      </table>
                    </td></tr>
                    <tr>
                      <th>Thickness: <br *ngIf="this.isPortrait">{{+box.finishedProduct.product?.thickness / 1000}}mm</th>
                      <th>Width: <br *ngIf="this.isPortrait">{{box.finishedProduct.content.energy.width}}mm</th>
                      <th>Length: <br *ngIf="this.isPortrait">{{box.finishedProduct.content.energy.rollLength}}m</th>
                      <th>Core: <br *ngIf="this.isPortrait">{{box.finishedProduct.content.energy.core?.name}}</th>
                    </tr>
                  </table>
                </div>

                <div class="vcenter box-label-lots">
                  <!-- <table *ngIf="box.details?.length < 7"> -->
                  <table>
                    <thead>
                      <tr>
                        <th style="text-align:center">Lot #</th>
                        <th style="text-align:center">TC #</th>
                        <th style="text-align:right">Q in pcs</th>
                        <th style="text-align:right">Q in lm</th>
                        <th *ngIf="showDateOfProd" style="text-align:center">Date of Prod.</th>
                        <th *ngIf="compilation.boxLabelConfig.mode > 2 && compilation.boxLabelConfig.mode !== 5" style="text-align:center">Min Shelf Life</th>
                        <th *ngIf="box.joints" style="text-align:center">Joints</th>
                      </tr>
                    </thead>
                    <tr>
                      <td colspan="100"><div class="thinborder-bottom"></div></td>
                    </tr>
                    <ng-container *ngFor="let item of box.details">
                      <tr>
                        <td style="text-align:center">{{item.lot}}</td>
                        <td style="text-align:center">{{item.tc}}</td>
                        <td style="text-align:right">{{item.quantity}}</td>
                        <td style="text-align:right">{{getLm(box, item)}}</td>
                        <td *ngIf="showDateOfProd" style="text-align:center">{{item.prodDate | date : 'yyyy-MM-dd'}}</td>
                        <td *ngIf="compilation.boxLabelConfig.mode > 2 && compilation.boxLabelConfig.mode !== 5" style="text-align:center">{{item.expiryDate | date : 'MMM yyyy'}}</td>
                        <td *ngIf="box.joints" style="text-align:center">{{item.joints}}</td>
                      </tr>
                    </ng-container>
                    <tbody *ngIf="box.details.length > 1" class="thinborder-top">
                      <tr>
                        <td style="text-align:center"><b>Total</b></td>
                        <td colspan="2" style="text-align:right"><b>{{getSumQuantity(box)}}</b></td>
                        <td style="text-align:right"><b>{{getSumLm(box)}}</b></td>
                        <td></td>
                        <td *ngIf="compilation.boxLabelConfig.mode > 2 && compilation.boxLabelConfig.mode !== 5"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- <div *ngIf="box.details[0].joints" class="vcenter box-label-footer" [style]="(box.box.remarks && shelfLifeOption !== 6) && (box.box.shelfLifeText && ![3,4].includes(shelfLifeOption)) ? null : { 'border-bottom': 'none' }"> -->
                <div *ngIf="box.joints" class="vcenter box-label-footer" [style]="!box.box.shelfLifeText?.length || (!box.box.remarks?.length && compilation.boxLabelConfig.mode === 6) || compilation.boxLabelConfig.mode === 7 ? { 'border-bottom': 'none' } : null">
                  <span *ngIf="box.joints">Number of rolls with joints in box: {{box.joints}}</span>
                  <!-- <div *ngIf="box.details[0].netWeight">Net weight in kg: {{box.details[0].netWeight}}</div>
                  <div *ngIf="box.details[0].grossWeight">Gross weight in kg: {{box.details[0].grossWeight}}</div> -->
                </div>

                <!-- <div *ngIf="box.box.shelfLifeText && ![3,4].includes(shelfLifeOption)" class="vcenter box-label-shelf-life"> -->
                <div *ngIf="box.box.shelfLifeText && ![6,7].includes(compilation.boxLabelConfig.mode)" class="vcenter box-label-shelf-life">
                  <ng-container *ngIf="compilation.boxLabelConfig.mode < 3 || compilation.boxLabelConfig.mode === 5">
                    <ng-container *ngIf="print">
                      <div>
                        <div *ngIf="box.box.shelfLifeDate">{{box.box.shelfLifeText}}</div>
                        <div *ngIf="!box.box.shelfLifeDate">{{box.box.shelfLifeText}}</div>
                      </div>
                      <div *ngIf="box.box.shelfLifeDate">
                        <div>Min Shelf Life</div>
                        <div><b>{{box.box.shelfLifeDate | date : 'MMM yyyy'}}</b></div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!print">
                      <div>
                        <ngx-form-text [multiline]="1" [(value)]="box.box.shelfLifeText"></ngx-form-text>
                      </div>
                      <div>
                        <ngx-doc-form-date [(value)]="$any(box.box).shelfLifeDate"></ngx-doc-form-date>
                      </div>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngIf="[3,4,8].includes(compilation.boxLabelConfig.mode)">
                    <div>{{box.box.shelfLifeText}}</div>
                  </ng-container>
                </div>

                <div *ngIf="compilation.boxLabelConfig.mode === 6 && box.box.remarks" class="vcenter box-label-shelf-life">
                  <div *ngIf="!print"><ngx-form-text [multiline]="1" [(value)]="box.box.remarks"></ngx-form-text></div>
                  <div *ngIf="print">{{box.box.remarks}}</div>
                </div>


                <div *ngIf="+box.box.palletRef > 0" class="pallet-id-label">Pallet ID: {{box.box.palletRef}}{{ !isPortrait && box.of > 1 ? ',  Box ID: ' + box.boxId + ' (' + box.el + '/' + box.of +')' : ''}}</div>

<!--                <div *ngIf="box.finishedProduct?.content?.energy?.core && isPortrait" class="box-label-left-bottom">
                  <div><qrcode [qrdata]="'{ boxId: ' + box.boxId + ' }'" [width]="120" [errorCorrectionLevel]="'Q'" elementType="svg"></qrcode></div>
                  <div class="numbers-left"><div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Case #</div><div>{{box.box.case}}</div></div>
                  <div class="numbers-left"><div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Box ID</div><div>{{box.boxId}}</div></div>
                  <!~~ <br *ngIf="" ~~>
                  <div *ngIf="box.finishedProduct?.content?.energy?.core?.coreImage?.length && !isPortrait" class="core-image">
                    <img [src]="'api/v1' + box.finishedProduct.content.energy.core.coreImage[0].url" />
                  </div>
                  <!~~ <div class="numbers-left"><div>Net weight (kg)</div><div>{{box.netWeight | ngxRound : 2 : true}}<br>{{box.details[0].netWeight // '---'}}</div></div> ~~>
                  <div class="numbers-left"><div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Quantity (m²)</div><div>{{getSqm(box)}}</div></div>
                  <div class="numbers-left"><div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Net weight (kg)</div><div>{{box.netWeight | ngxRound : 2 : true}}</div></div>
                  <div *ngIf="+box.box.grossWeightOverride > 0; else xlsGrossWeight" class="numbers-left">
                    <div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Gross weight (kg)</div><div>{{(+box.box.grossWeightOverride).toFixed(2)}}</div>
                  </div>
                  <ng-template #xlsGrossWeight><div *ngIf="+box.grossWeight > 0" class="numbers-left">
                    <div [class.no-core-img]="!box.finishedProduct?.content?.energy?.core?.coreImage?.length || isPortrait">Gross weight (kg)</div><div>{{(+box.grossWeight).toFixed(2)}}</div>
                  </div></ng-template>
                </div>    -->

                <div *ngIf="box.finishedProduct?.content?.energy?.core && isPortrait" class="box-label-bottom">
                  <div><qrcode [qrdata]="'{ boxId: ' + box.boxId + ' }'" [width]="120" [errorCorrectionLevel]="'Q'" elementType="svg"></qrcode></div>
                  <div>
                    <div class="numbers-left"><div>Case #</div><div>{{box.box.case}}</div></div>
                    <div class="numbers-left"><div>Box ID</div>
                      <div>{{box.boxId}}<ng-container *ngIf="box.of > 1"><br>({{box.el}}/{{box.of}})</ng-container></div>
                    </div>
                  </div>
                  <div>
                    <div class="numbers-left"><div>Quantity (m²)</div><div>{{getSqm(box)}}</div></div>
                    <div class="numbers-left"><div>Net weight (kg)</div><div>{{box.netWeight | ngxRound : 2 : true}}</div></div>
                    <div *ngIf="+box.box.grossWeightOverride > 0; else xlsGrossWeight" class="numbers-left">
                      <div>Gross weight (kg)</div><div>{{(+box.box.grossWeightOverride).toFixed(2)}}</div>
                    </div>
                    <ng-template #xlsGrossWeight><div *ngIf="+box.grossWeight > 0" class="numbers-left">
                      <div>Gross weight (kg)</div><div>{{(+box.grossWeight).toFixed(2)}}</div>
                    </div></ng-template>  
                  </div>
                </div>
  
              </div>

              <!-- <div *ngIf="this.isPortrait" class="qrcode"><qrcode [qrdata]="'{ boxId: ' + box.boxId + ' }'" [width]="120" [errorCorrectionLevel]="'Q'" elementType="svg"></qrcode></div> -->
            
            </div>

          </div>
        </div>
        </div>

        <div *ngIf="compilation.boxLabelConfig.mode === 7" class="box-label-page">
          <div class="box-label-container">
            <div class="box-label-remarks">
              Box ID: {{box.box.boxId}}<br><br>
              <div  [ngStyle]="{
                'font-size': compilation.boxLabelConfig.fontSize + 'pt',
                'line-height': compilation.boxLabelConfig.fontSize + 'pt',
                'text-align': compilation.boxLabelConfig.textCentered ? 'center' : 'left'
                }">
                <ngx-form-text *ngIf="!print" [multiline]="20" [(value)]="box.box.remarks"
                [styles]="{
                  'font-size': compilation.boxLabelConfig.fontSize + 'pt',
                  'line-height': compilation.boxLabelConfig.fontSize + 'pt',
                  'font-weight':'bold',
                  'text-align': compilation.boxLabelConfig.textCentered ? 'center' : 'left'
                }"></ngx-form-text>
                <div *ngIf="print">{{box.box.remarks}}</div>
              </div>
            </div>
          </div>
        </div>
      

      </ng-container>

<!--      <ng-container *ngFor="let box of boxes">

        <div *ngIf="box.selected || !print" class="inventory-labels inventory-labels-display" style="position: relative;page-break-before:always">

          <div style="border: 1px solid lightgray; padding: 3mm 0; background-color: #eee; margin-bottom: 5mm; font-size:2rem">
            <table class="inventory-labels-header">
              <tr>
                <td *ngIf="!print"><input style="transform:scale(2) translate(-14px,0)" type="checkbox" [(ngModel)]="box.selected" /></td>
                <th style="text-align:right;padding-right:5mm">Box ID:</th>
                <td>{{box.boxId}}</td>
                <th style="text-align:right;padding-right:5mm">Case #:</th>
                <td>{{box.box.case}}</td>
              </tr>
            </table>
          </div>
      
          <div style="width: 200mm; float: left; margin-right: 5mm;">
            <table class="nrk-table">
              <tr>
                <th style="text-align:left; padding-left:5mm">Customer</th>
                <td style="padding-left:3mm">{{box.customer?.name}}</td>
              </tr>
              <tr>
                <th style="text-align:left; padding-left:5mm">Customer PO & Pos</th>
                <td style="padding-left:3mm">{{box.oc.customerDocumentNumber}} Pos {{tree.getItemOrderPos(box.lineItem) + ''}}</td>
              </tr>
              <tr>
                <th style="text-align:left; padding-left:5mm">Customer Material Name</th>
                <td style="padding-left:3mm">{{box.finishedProduct.externalName}}</td>
              </tr>
              <tr>
                <th style="text-align:left; padding-left:5mm">Customer Material Code</th>
                <td style="padding-left:3mm">{{box.finishedProduct.externalCode}}</td>
              </tr>
              <tr>
                <th style="text-align:left; padding-left:5mm">Supplier Product Code</th>
                <td style="padding-left:3mm">{{box.finishedProduct.calcCode}}</td>
              </tr>
              <tr>
                <th style="text-align:left; padding-left:5mm">Supplier Product Name</th>
                <td style="padding-left:3mm">{{box.finishedProduct.calcName}}</td>
              </tr>
            </table>
            <br>
            <table class="nrk-table" *ngIf="box.details?.length < 5">
              <tr>
                <th style="text-align:center">Lot #</th>
                <th style="text-align:center">TC #</th>
                <th style="text-align:right">Q in pcs</th>
                <th style="text-align:right">Q in lm</th>
                <th style="text-align:center">Date of Production</th>
                <th *ngIf="shelfLifeOption > 2 && shelfLifeOption !== 5" style="text-align:center">Expiry Date</th>
              </tr>
              <ng-container *ngFor="let item of box.details">
                <tr>
                  <td style="text-align:center">{{item.lot}}</td>
                  <td style="text-align:center">{{item.tc}}</td>
                  <td style="text-align:right">{{item.quantity}}</td>
                  <td style="text-align:right">{{getLm(box, item)}}</td>
                  <td style="text-align:center">{{item.prodDate | date : 'yy-MM-dd'}}</td>
                  <td *ngIf="shelfLifeOption > 2 && shelfLifeOption !== 5" style="text-align:center">{{item.expiryDate | date : 'MMM yyyy'}}</td>
                </tr>
              </ng-container>
              <tr *ngIf="box.details.length > 1" style="background-color: #eee">
                <td colspan="3" style="text-align:right"><b>Total</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{getSumQuantity(box)}}</td>
                <td style="text-align:right">{{getSumLm(box)}}</td>
                <td></td>
                <td *ngIf="shelfLifeOption > 2 && shelfLifeOption !== 5"></td>
              </tr>
            </table>
          </div>
      
          <div style="width: 34mm; float: right;">
            <div style="text-align:center;border:1px solid lightgray;padding-top:2px">
              <!~~ <qr-code [value]="'{ boxId: ' + box.boxId + '}'" size="30mm" errorCorrectionLevel="Q" centerImageSrc="undefined"
                centerImageSize="undefined" [margin]="0"></qr-code> ~~>
              <qrcode [qrdata]="'{ boxId: ' + box.boxId + ' }'" [width]="120" [errorCorrectionLevel]="'Q'" elementType="svg"></qrcode>
            </div>
            <div *ngIf="box.finishedProduct.customerIdentificator" class="inventory-labels-image" style="width:34mm;height:33mm;padding-top:2mm;margin-top:27mm;text-align:center;border:1px solid lightgray">
              <img style="width:30mm;height:30mm" [src]="'api/v1' + box.finishedProduct.customerIdentificator?.url" alt="Customer ID" />
            </div>
          </div>
      
          <div [ngStyle]="{position: 'absolute', top: print ? '165mm' : '140mm'}">
            <div style="position: absolute; bottom: 0; width: 100%;">
              <div style="width:240mm;margin-bottom:2mm;padding:1mm;border:1px solid lightgray;text-align:center" *ngIf="box.details[0].joints || box.details[0].netWeight || box.details[0].grossWeight">
                <div style="display:inline-block;width:80mm" *ngIf="box.details[0].joints">Number of rolls with joints in box: {{box.details[0].joints}}</div>
                <div style="display:inline-block;width:70mm" *ngIf="box.details[0].netWeight">Net weight in kg: {{box.details[0].netWeight}}</div>
                <div style="display:inline-block;width:60mm" *ngIf="box.details[0].grossWeight">Gross weight in kg: {{box.details[0].grossWeight}}</div>
              </div>
        
              <div *ngIf="shelfLifeOption < 3 || shelfLifeOption === 5" style="padding:1mm;font-size:1.3rem;border:1px solid lightgray;width:240mm">
                <div *ngIf="print">
                  <div style="display:inline-block;width:175mm;">
                    <div *ngIf="box.box.shelfLifeDate" style="position:relative;left:3mm;top:-3mm">
                      {{box.box.shelfLifeText}}
                    </div>
                    <div *ngIf="!box.box.shelfLifeDate" style="text-align:center;width:235mm">
                      {{box.box.shelfLifeText}}
                    </div>
                  </div>
                  <div *ngIf="box.box.shelfLifeDate" style="display:inline-block;padding-left:13mm;text-align:center">
                    <div style="font-size:0.9rem;position:relative;top:2mm">Expiry Date</div>
                    <div style="font-size:2rem;padding:2.2mm"><b>{{box.box.shelfLifeDate | date : 'MMM yyyy'}}</b></div>
                  </div>
                </div>
                <div *ngIf="!print">
                  <div style="display:inline-block;width:165mm;">
                    <ngx-form-text [multiline]="1" [(value)]="box.box.shelfLifeText"></ngx-form-text>
                  </div>
                  <div style="display:inline-block;padding-left:5mm">
                    <ngx-doc-form-date [(value)]="$any(box.box).shelfLifeDate"></ngx-doc-form-date>
                  </div>
                </div>
              </div>
            </div>
          </div>
      
        </div>

        <div *ngIf="box.details?.length > 4 && box.selected" class="inventory-labels inventory-labels-display" style="page-break-before:always">
          <div style="border: 1px solid lightgray; padding: 3mm 0; background-color: #eee; margin-bottom: 5mm; font-size:2rem">
            <table class="inventory-labels-header">
              <tr>
                <td *ngIf="!print"></td>
                <th style="text-align:right;padding-right:5mm">Box ID:</th>
                <td>{{box.boxId}}</td>
                <th style="text-align:right;padding-right:5mm">Case #:</th>
                <td>{{box.box.case}}</td>
              </tr>
            </table>
          </div>
          <table class="nrk-table" style="width:100%">
            <tr>
              <th style="text-align:center">Lot #</th>
              <th style="text-align:center">TC #</th>
              <th style="text-align:right">Q in pcs</th>
              <th style="text-align:right">Q in lm</th>
              <th style="text-align:center">Date of Production</th>
              <th *ngIf="shelfLifeOption > 2 && shelfLifeOption !== 5" style="text-align:center">Expiry Date</th>
            </tr>
            <ng-container *ngFor="let item of box.details">
              <tr>
                <td style="text-align:center">{{item.lot}}</td>
                <td style="text-align:center">{{item.tc}}</td>
                <td style="text-align:right">{{item.quantity}}</td>
                <td style="text-align:right">{{getLm(box, item)}}</td>
                <td style="text-align:center">{{item.prodDate | date : 'yy-MM-dd'}}</td>
                <td *ngIf="shelfLifeOption > 2 && shelfLifeOption !== 5" style="text-align:center">{{item.expiryDate | date : 'MMM yyyy'}}</td>
              </tr>
            </ng-container>
            <tr *ngIf="box.details.length > 1" style="background-color: #eee">
              <td colspan="3" style="text-align:right"><b>Total</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{getSumQuantity(box)}}</td>
              <td style="text-align:right">{{getSumLm(box)}}</td>
              <td></td>
              <td *ngIf="shelfLifeOption > 2 && shelfLifeOption !== 5"></td>
            </tr>
          </table>
        </div>

      </ng-container>
-->    </div>
</ng-template>
